<template>
  <div class="technology">
    <div class="banner">
      <div class="left">
        <div class="title_box">
          <div class="big_title">服务化与支持</div>
          <div class="small_title">Service and Support</div>
        </div>
      </div>
    </div>
    <div>
      <div class="container">
        <div class="content">
          <!-- 页面标题 -->
          <div class="title-section">
            <h1>服务支持全程无忧</h1>
            <!-- <div class="controls">
              <div class="control-item">
                <input type="checkbox" id="expand" v-model="isExpanded">
                <label for="expand">全部展开</label>
              </div>
              <div class="control-item">
                <input type="checkbox" id="difference" v-model="showDifference">
                <label for="difference">仅显示差异</label>
              </div>
            </div> -->
          </div>

          <!-- 版本服务表格 -->
          <div class="comparison-table">
            <!-- 表头 -->
            <div class="table-header">
              <div class="header-cell feature-header">
                <span style="font-size: 26px;text-align: center;font-weight: 600;color: #252E3E;">服务支持</span>
              </div>
              <div v-for="(plan, index) in plans" :key="index"
                :class="['header-cell plan-header', getPlanHeaderClass(plan.type)]">
                <h3>{{ plan.name }}</h3>
<!--                <p style="font-size: 16px;color: #999999;">{{ plan.price }}</p>-->
              </div>
            </div>
            <!-- 功能列表 -->
            <div class="table-body">
              <div v-for="(feature, index) in services" :key="index">
                <div :class="['table-row', { 'striped': index % 2 === 0 }]">
                  <div class="feature-cell">
                    <span>{{ feature.name }}</span>
                  </div>
                  <div v-for="(plan, planIndex) in plans" :key="planIndex" class="plan-cell">
                    <div v-if="feature.values[planIndex]" :class="['feature-value', getPlanTextClass(plan.type)]">
                      <i class="fas fa-check"></i>
                      <span v-if="feature.details"  style="font-size: 12px;" class="detail">{{ feature.details[planIndex] }}</span>
                    </div>
                    <i v-else class="fas fa-minus minus-icon"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="title-section" style="margin-top: 50px;">
            <h1>产品功能</h1>
          </div>
          <!-- 版本对比表格 -->
          <div class="comparison-table">
            <!-- 表头 -->
            <div class="table-header">
              <div class="header-cell feature-header">
                <span style="font-size: 26px;text-align: center;font-weight: 600;color: #252E3E;">版本明细</span>
              </div>
              <div v-for="(plan, index) in plans" :key="index"
                :class="['header-cell plan-header', getPlanHeaderClass(plan.type)]">
                <h3>{{ plan.name }}</h3>
                <p style="font-size: 22px;color: #020202;font-weight: 300;">{{ plan.price }}</p>
              </div>
            </div>
            <!-- 功能列表 -->
            <div class="table-body">
              <div v-for="(feature, index) in features" :key="index">
                <div :class="['table-row', { 'striped': index % 2 === 0 }]">
                  <div class="feature-cell">
                    <span>{{ feature.name }}</span>
                  </div>
                  <div v-for="(plan, planIndex) in plans" :key="planIndex" class="plan-cell">
                    <div v-if="feature.values[planIndex]" :class="['feature-value', getPlanTextClass(plan.type)]">
                      <i class="fas fa-check"></i>
                      <span v-if="feature.details"  style="font-size: 12px;" class="detail">{{ feature.details[planIndex] }}</span>
                    </div>
                    <i v-else class="fas fa-minus minus-icon"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="text-align: center;margin-top: 50px;">
            <div class="phoneTitle">您可以通过以下方式与我们取得联系：</div>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <div style="width: 30%;margin-top:50px">
                <div><img style="height: 45px;" src="@/assets/座机号码@2x.png" alt=""></div>
                <div class="phoneTitle">咨询服务电话(同微信)</div>
                <div class="phoneTitle">180-2666-8608</div>
              </div>
              <div style="width: 30%;margin-top:50px">
                <div><img style="height: 45px;" src="@/assets/电话圆框@2x.png" alt=""></div>
                <div class="phoneTitle">技术支持电话</div>
                <div class="phoneTitle">180-2666-8608</div>
              </div>
              <div style="width: 30%;margin-top:50px">
                <div><img style="height: 45px;" src="@/assets/邮箱@2x.png" alt=""></div>
                <div class="phoneTitle">邮箱</div>
                <div class="phoneTitle">manager@create-gain.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExpanded: false,
      showDifference: false,
      plans: [
        {
          type: 'basic',
          name: '基础版',
          price: '¥999元/年'
        },
        {
          type: 'standard',
          name: '标准版',
          price: '¥2,999元/年'
        },
        {
          type: 'enterprise',
          name: '旗舰版',
          price: '¥4,999元/年'
        },{
          type: 'custom',
          name: '定制版',
          price: '商议'
        }
      ],
      services: [
        {
          name: '免费版本更新',
          values: [true, true, true, true]
        },
        {
          name: '独立数据空间',
          values: [true, true, true, true]
        },
        {
          name: '专属客户经理',
          values: [false, true, true, true]
        },
        {
          name: '专属客户群',
          values: [true, true, true, true]
        },
        {
          name: '7×24小时技术支持',
          values: [false, true, true, true]
        },
        {
          name: '远程维护与监控',
          values: [true, true, true, true]
        }
      ],
      features: [
        {
          name: '医疗管理',
          values: [true, true, true, true]
        },
        {
          name: '预约挂号',
          values: [true, true, true, true]
        },
        {
          name: '门诊接诊',
          values: [true, true, true, true]
        },
        {
          name: '处方开具',
          values: [true, true, true, true]
        },
        {
          name: 'AI辅助诊断',
          values: [false, true, true, true]
        },
        {
          name: 'AI病历模板',
          values: [false, true, true, true]
        },
        {
          name: 'AI语音转病历',
          values: [false, true, true, true]
        },
        {
          name: '病情回访',
          values: [false, true, true, true]
        },
        {
          name: '分类收费',
          values: [true, true, true, true]
        },
        {
          name: '药房发药',
          values: [true, true, true, true]
        },
        {
          name: '理疗核销/处置',
          values: [true, true, true, true]
        },
        {
          name: '零售开单',
          values: [true, true, true, true]
        },
        {
          name: '药品零售',
          values: [true, true, true, true]
        },
        {
          name: '药品盘点',
          values: [true, true, true, true]
        },
        {
          name: '库存预警',
          values: [true, true, true, true]
        },
        {
          name: '供应商管理',
          values: [true, true, true, true]
        },
        {
          name: '患者档案',
          values: [true, true, true, true]
        },
        {
          name: '项目套餐',
          values: [true, true, true, true]
        },
        {
          name: '医师人才库',
          values: [true, true, true, true]
        },
        {
          name: '医保对接',
          values: [false, true, true, true]
        },
        {
          name: '客户营销',
          values: [false, false, true, true]
        },
        {
          name: '会员管理',
          values: [false, false, true, true]
        },
        {
          name: '会员积分',
          values: [false, false, true, true]
        },
        {
          name: '会员折扣',
          values: [false, false, true, true]
        },
        {
          name: '服务提醒',
          values: [false, false, true, true]
        },
        {
          name: '营销活动策划',
          values: [false, false, true, true]
        },
        {
          name: '营销折扣',
          values: [false, false, true, true]
        },
        {
          name: '营销满减',
          values: [false, false, true, true]
        },
        {
          name: '分享裂变',
          values: [false, false, true, true]
        },
        {
          name: 'AI会员分析',
          values: [false, false, true, true]
        },
        {
          name: 'AI活动策划',
          values: [false, false, true, true]
        },
        {
          name: '营销后评估',
          values: [false, false, true, true]
        },
        {
          name: '员工档案',
          values: [false, true, true, true]
        },
        {
          name: '人员需求',
          values: [false, true, true, true]
        },
        {
          name: '入职离职',
          values: [false, true, true, true]
        },
        {
          name: '转正调配',
          values: [false, true, true, true]
        },
        {
          name: '社保公积金',
          values: [false, true, true, true]
        },
        {
          name: '请假申请',
          values: [false, true, true, true]
        },
        {
          name: '员工通讯录',
          values: [false, true, true, true]
        },
        {
          name: '绩效考核',
          values: [false, true, true, true]
        },
        {
          name: '物品管理',
          values: [false, true, true, true]
        },
        {
          name: '报餐管理',
          values: [false, true, true, true]
        },
        {
          name: '日程任务',
          values: [false, true, true, true]
        },
        {
          name: '会议管理',
          values: [false, true, true, true]
        },
        {
          name: '报销管理',
          values: [false, true, true, true]
        },
        {
          name: '财务管理',
          values: [false, true, true, true]
        },
        {
          name: '组织架构',
          values: [true, true, true, true]
        },
        {
          name: '角色权限',
          values: [true, true, true, true]
        },
        {
          name: '流程引擎',
          values: [true, true, true, true]
        },
        {
          name: '定制统计报表',
          values: [false, true, true, true]
        },
        {
          name: '多端服务',
          values: [true, true, true, true]
        },
        {
          name: '客户小程序',
          values: [true, true, true, true]
        },
        {
          name: '医疗移动端',
          values: [true, true, true, true]
        },
        {
          name: '叫号系统',
          values: [false, true, true]
        },
        {
          name: '个性化需求定制开发',
          values: [false, false, false, true]
        }
      ],
      productEngineActive: 0,
      productEngineList: [
        {
          name: '表单引擎',
          icon: require('../../../assets/表单引擎.png'),
          selectIcon: require('../../../assets/表单引擎选中.png')
        },
        {
          name: '流程引擎',
          icon: require('../../../assets/流程引擎.png'),
          selectIcon: require('../../../assets/流程引擎选中.png')
        },
        {
          name: '规则引擎',
          icon: require('../../../assets/规则引擎.png'),
          selectIcon: require('../../../assets/规则引擎选中.png')
        },
      ],
      pocumentCollaborationActive: 0,
      pocumentCollaborationList: [
        {
          name: '文档协同',
          icon: require('../../../assets/文档协同.png'),
          selectIcon: require('../../../assets/文档协同选中.png')
        },
        {
          name: '在线文档',
          icon: require('../../../assets/在线文档.png'),
          selectIcon: require('../../../assets/在线文档选中.png')
        },
      ]
    }
  },
  methods: {
    getPlanHeaderClass(type) {
      return type;
    },
    getPlanTextClass(type) {
      return type;
    },
    changeProductEngineList(index) {
      this.productEngineActive = index
    },
    changePocumentCollaborationList(index) {
      this.pocumentCollaborationActive = index
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .technology {
    .banner {
      min-width: auto !important;
      height: 9rem !important;
      background-position: center !important;

      .left {
        width: 100%;
        height: auto;
        padding-left: 1.5rem;

        .title_box {
          height: auto;

          .big_title {
            font-size: 0.9rem !important;
          }

          .small_title {
            font-size: 0.6rem !important;
          }
        }
      }
    }
  }
  .phoneTitle {
    font-size: 10px !important;
  }
}
.phoneTitle {
  font-weight: 500;
  font-size: 23px;
  color: #252E3E;
}
.container {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 48px 0;
  display: flex;
  justify-content: center;
}

.content {
  width: 1440px;
  min-height: 1024px;
}

.title-section {
  text-align: center;
  margin-bottom: 48px;
}

.title-section h1 {
  font-size: 30px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 24px;
}

.controls {
  display: flex;
  justify-content: center;
  gap: 32px;
}

.control-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-item label {
  font-size: 14px;
  color: #4b5563;
}

.comparison-table {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  border-bottom: 1px solid #e5e7eb;
}

.header-cell {
  padding: 24px;
}

.feature-header {
  background-color: #f9fafb;
}

.feature-header h3 {
  font-size: 18px;
  font-weight: 500;
  color: #111827;
}

.plan-header {
  text-align: center;
}

.plan-header.basic {
  background-color: #f0fdf4;
}

.plan-header.standard {
  background-color: #eff6ff;
}

.plan-header.enterprise {
  background-color: #fff7ed;
}

.plan-header h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
}

.price {
  font-size: 14px;
  color: #4b5563;
}

.table-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.striped {
  background-color: #f9fafb;
}

.feature-cell {
  padding: 24px;
  display: flex;
  align-items: center;
}

.feature-cell span {
  color: #111827;
}

.plan-cell {
  padding: 24px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-value {
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-value.basic {
  color: #16a34a;
}

.feature-value.standard {
  color: #2563eb;
}

.feature-value.enterprise {
  color: #ea580c;
}

.feature-value.custom {
  color: #ff0000;
}

.detail {
  margin-left: 8px;
}

.minus-icon {
  color: #9ca3af;
}

.footer-note {
  margin-top: 32px;
  text-align: center;
  font-size: 14px;
  color: #4b5563;
}

input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

input[type="checkbox"]:checked {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.technology {
  .banner {
    min-width: 1024px;
    width: 100%;
    height: 20rem;
    background-image: url('../../../assets/组5324@2x.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 43%;
      height: 70%;
      //background: red;
      padding-left: 2.8rem;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title_box {
        height: 4.1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .big_title {
          font-weight: 500;
          font-size: 1.6rem;
          color: #000000;
        }

        .small_title {
          font-weight: 500;
          font-size: 1.4rem;
          color: #000000;
        }
      }
    }
  }

  .technology_contact {
    min-width: 1024px;
    width: 100%;
    padding-top: 3.2rem;
    padding-bottom: 4.8rem;
    color: #333333;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin-bottom: 0.6rem;
      font-size: 0.88rem;
      font-weight: 600;
      display: flex;
      align-items: center;
      /* 垂直居中对齐 */
    }

    .kelete {
      width: 90px;
      margin-right: 5px;
    }

    .subtitle {
      font-size: 0.56rem;
      color: #999999;
      margin-bottom: 1.2rem;
    }

    .bg {
      width: 79%;
      height: 32.4rem;
      background-image: url('../../../assets/technology2.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .bg2 {
      width: 79%;
      height: 32.4rem;
      background-image: url('../../../assets/technology3.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .bg3 {
      width: 79%;
      height: 32.4rem;
      background-image: url('../../../assets/technology4.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .container {
      width: 85%;

      .container_top {
        border-bottom: 0.04rem solid #dbdbdb;
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 1.6rem;

        .container_top_inside {
          width: 32%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          color: #333333;

          .item {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 3.6rem;
            height: 1.48rem;
            cursor: pointer;

            .item_img {
              width: 0.7rem;
              height: 0.7rem;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .item_text {
              font-size: 0.56rem;
            }
          }

          .active {
            color: #4e78ff;
            border-bottom: 0.12rem solid #4e78ff;
          }
        }
      }

      .conatiner_bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .conatiner_bottom_left {
          width: 27%;
          height: 4.16rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .top {
            font-size: 0.8rem;
            font-weight: 600;
            color: #333333;
          }

          .bottom {
            font-size: 0.56rem;
            color: #999999;
            line-height: 0.8rem;
          }
        }

        .container_bottom_right1 {
          width: 65%;
          height: 19.64rem;
          background-image: url('../../../assets/表单引擎大图.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .container_bottom_right2 {
          width: 65%;
          height: 19.64rem;
          background-image: url('../../../assets/流程引擎大图.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .container_bottom_right3 {
          width: 65%;
          height: 19.64rem;
          background-image: url('../../../assets/规则引擎大图.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .container_bottom_right4 {
          width: 65%;
          height: 19.64rem;
          background-image: url('../../../assets/文档协同大图.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .container_bottom_right5 {
          width: 65%;
          height: 19.64rem;
          background-image: url('../../../assets/在线文档.jpg');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
  }
}

.trial-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 24px;
  margin-bottom: 32px;
}

.trial-content {
  max-width: 1000px;
  margin: 0 auto;
}

.trial-title {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 600;
  color: #252E3E;
}

.wework-icon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.trial-description {
  color: #252E3E;
  font-size: 16px;
  line-height: 1.6;
}

.trial-description p {
  margin-bottom: 16px;
}

.trial-steps {
  margin-left: 24px;
  margin-bottom: 24px;
}

.trial-steps li {
  margin-bottom: 8px;
}

.trial-note {
  background-color: #f0f9ff;
  border-left: 4px solid #3b82f6;
  padding: 12px 16px;
  color: #1e40af;
  font-size: 14px;
}
</style>
